import React from "react"
import "./DashboardShowMoreButton.style.scss"

interface DashboardShowMoreButtonProps {
  expanded: boolean
  extraCount: number
  onToggle: () => void
}

const DashboardShowMoreButton = ({
  expanded,
  extraCount,
  onToggle,
}: DashboardShowMoreButtonProps) => {
  if (extraCount <= 0) return null
  return (
    <button
      type="button"
      className="dashboard-show-more"
      onClick={onToggle}
    >
      {expanded ? "Show less" : `Show more (${extraCount})`}
    </button>
  )
}

export default DashboardShowMoreButton
